<template>
  <div class="text-left">
    <h5 v-if="supervisor" class="text-center">
      <strong>{{ $t("supervisor") }}:</strong> {{ supervisor.username }}
    </h5>
    <v-divider />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <SoftwareFields
          :software="software"
          :editor-ready="loaded"
          readonly
        />
        <v-divider />
        <DirectorActions
          v-if="isAuthorize"
          object_type="software"
          class="text-center"
        />
        <SupervisorActions
          v-else
          :item="software"
          object_type="software"
          :form_name="formName"
          :state="state"
          :supervisor="supervisor ? supervisor.username : ''"
          @change-state-supervisor="onStateSupervisorChange"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "@/components/action_buttons/DirectorActions";
import SupervisorActions from "@/components/action_buttons/SupervisorActions";
import SoftwareFields from "@/components/software/SoftwareFields.vue";
import { createDefaultSoftware, normalizeSoftware } from "@/utils/software";

export default {
  name: "ReviewSoftwareForms",
  components: { DirectorActions, SoftwareFields, SupervisorActions },
  data: () => ({
    software: createDefaultSoftware(),
    formName: "",
    state: "",
    supervisor: null,
    loaded: false
  }),
  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      axios
        .get(`${this.$store.state.endpoint}/moderatedOperations/review/software/${this.$route.params.id}`)
        .then(response => {
          this.software = normalizeSoftware(response.data.data.user.software);
          this.software.image_squared = response.data.image_squared || "";
          this.software.image_horizontal = response.data.image_horizontal || "";
          this.software.id = response.data.object_id;
          this.software.reject_comment = response.data.reject_comment || "";
          this.formName = response.data.form_name;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.loaded = true;
        });
    },
    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
